import { Controller } from "@hotwired/stimulus";

// Shows the text box under an "Other" choice only while that choice is
// selected. Wraps a radio or checkbox group; each text box is a `text` target
// inside the same <label> as its choice input, so no ids need to line up.
// Connects to data-controller="other-option"
export default class extends Controller {
  static targets = ["text"];

  declare readonly textTargets: HTMLInputElement[];

  connect() {
    this.sync();
  }

  sync() {
    this.textTargets.forEach((text) => {
      const choice = text
        .closest("label")
        ?.querySelector<HTMLInputElement>('input[type="radio"], input[type="checkbox"]');
      const selected = choice?.checked ?? false;

      text.classList.toggle("hidden", !selected);
      if (!selected) text.value = "";
    });
  }
}
